export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/postcard_design.f4d9fa1.svg";